<!-- Start: Header -->
<!-----------------------------------------------------------------+
       ".navbar" Helper Classes:
    -------------------------------------------------------------------+
       * Positioning Classes:
        '.navbar-static-top' - Static top positioned navbar
        '.navbar-static-top' - Fixed top positioned navbar

       * Available Skin Classes:
         .bg-dark    .bg-primary   .bg-success
         .bg-info    .bg-warning   .bg-danger
         .bg-alert   .bg-system
    -------------------------------------------------------------------+
      Example: <header class="navbar navbar-fixed-top bg-primary">
      Results: Fixed top navbar with blue background
    ------------------------------------------------------------------->
<header id="header" class="navbar navbar-fixed-top navbar-shadow bg-primary">
    <div class="navbar-branding">
       <!--  <a class="navbar-brand" href="dashboard.html">
            <b>Absolute</b>Adminssss
        </a>-->
        <img  class="navbar-brand" src="../../../assets/img/applogo.png">


        <span id="toggle_sidemenu_l" class="ad ad-lines"></span>
    </div>
    <!--  <ul class="nav navbar-nav navbar-left"> -->


    <!--  <li class="dropdown menu-merge hidden-xs">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">Dropdown
            <span class="caret caret-tp"></span>
          </a>
            <ul class="dropdown-menu" role="menu">
                <li><a href="#">Action</a></li>
                <li><a href="#">Another action</a></li>
                <li><a href="#">Something else here</a></li>
                <li class="divider"></li>
                <li><a href="#">Separated link</a></li>
            </ul>
        </li> -->


    <!--  <li class="hidden-xs">
            <a class="request-fullscreen toggle-active" href="#">
                <span class="ad ad-screen-full fs18"></span>
            </a>
        </li> -->
    <!--  </ul> -->
    <form class="navbar-form navbar-left navbar-search alt" role="search">
        <div class="form-group">
            <input type="text" class="form-control" placeholder="Search..." value="Search...">
        </div>
    </form>
    <ul class="nav navbar-nav navbar-right">

        <li class="dropdown menu-merge">
            <div class="navbar-btn btn-group">
                <button data-toggle="dropdown" class="btn btn-sm dropdown-toggle">
              <span class="fa fa-bell-o fs14 va-m"></span>
              <span class="badge badge-danger">9</span>
            </button>
                <div class="dropdown-menu dropdown-persist w350 animated animated-shorter fadeIn" role="menu">
                    <div class="panel mbn">
                        <div class="panel-menu">
                            <span class="panel-icon"><i class="fa fa-clock-o"></i></span>
                            <span class="panel-title fw600"> Recent Activity</span>
                            <button class="btn btn-default light btn-xs pull-right" type="button"><i class="fa fa-refresh"></i></button>
                        </div>
                        <div class="panel-body panel-scroller scroller-navbar scroller-overlay scroller-pn pn">
                            <ol class="timeline-list">
                                <li class="timeline-item">
                                    <div class="timeline-icon bg-dark light">
                                        <span class="fa fa-tags"></span>
                                    </div>
                                    <div class="timeline-desc">
                                        <b>Michael</b> Added to his store:
                                        <a href="#">Ipod</a>
                                    </div>
                                    <div class="timeline-date">1:25am</div>
                                </li>
                                <li class="timeline-item">
                                    <div class="timeline-icon bg-dark light">
                                        <span class="fa fa-tags"></span>
                                    </div>
                                    <div class="timeline-desc">
                                        <b>Sara</b> Added his store:
                                        <a href="#">Notebook</a>
                                    </div>
                                    <div class="timeline-date">3:05am</div>
                                </li>
                                <li class="timeline-item">
                                    <div class="timeline-icon bg-success">
                                        <span class="fa fa-usd"></span>
                                    </div>
                                    <div class="timeline-desc">
                                        <b>Admin</b> created invoice for:
                                        <a href="#">Software</a>
                                    </div>
                                    <div class="timeline-date">4:15am</div>
                                </li>
                                <li class="timeline-item">
                                    <div class="timeline-icon bg-success">
                                        <span class="fa fa-usd"></span>
                                    </div>
                                    <div class="timeline-desc">
                                        <b>Admin</b> created invoice for:
                                        <a href="#">Apple</a>
                                    </div>
                                    <div class="timeline-date">7:45am</div>
                                </li>
                                <li class="timeline-item">
                                    <div class="timeline-icon bg-success">
                                        <span class="fa fa-usd"></span>
                                    </div>
                                    <div class="timeline-desc">
                                        <b>Admin</b> created invoice for:
                                        <a href="#">Software</a>
                                    </div>
                                    <div class="timeline-date">4:15am</div>
                                </li>
                                <li class="timeline-item">
                                    <div class="timeline-icon bg-success">
                                        <span class="fa fa-usd"></span>
                                    </div>
                                    <div class="timeline-desc">
                                        <b>Admin</b> created invoice for:
                                        <a href="#">Apple</a>
                                    </div>
                                    <div class="timeline-date">7:45am</div>
                                </li>
                                <li class="timeline-item">
                                    <div class="timeline-icon bg-dark light">
                                        <span class="fa fa-tags"></span>
                                    </div>
                                    <div class="timeline-desc">
                                        <b>Michael</b> Added his store:
                                        <a href="#">Ipod</a>
                                    </div>
                                    <div class="timeline-date">8:25am</div>
                                </li>
                                <li class="timeline-item">
                                    <div class="timeline-icon bg-system">
                                        <span class="fa fa-fire"></span>
                                    </div>
                                    <div class="timeline-desc">
                                        <b>Admin</b> created invoice for:
                                        <a href="#">Software</a>
                                    </div>
                                    <div class="timeline-date">4:15am</div>
                                </li>
                                <li class="timeline-item">
                                    <div class="timeline-icon bg-dark light">
                                        <span class="fa fa-tags"></span>
                                    </div>
                                    <div class="timeline-desc">
                                        <b>Sara</b> Added to his store:
                                        <a href="#">Notebook</a>
                                    </div>
                                    <div class="timeline-date">3:05am</div>
                                </li>
                            </ol>

                        </div>
                        <div class="panel-footer text-center p7">
                            <a href="#" class="link-unstyled"> View All </a>
                        </div>
                    </div>
                </div>
            </div>
        </li>

        <li class="menu-divider hidden-xs">
            <i class="fa fa-circle"></i>
        </li>
        <li class="dropdown menu-merge">
            <a href="#" class="dropdown-toggle fw600 p15" data-toggle="dropdown">
                <img [src]="user.img" alt="avatar" class="mw50 img-circle">
                <span class="hidden-xs pl15">  {{ user.firstname }} {{user.lastname}} </span>
                <span class="caret caret-tp hidden-xs"></span>
            </a>
            <ul class="dropdown-menu list-group dropdown-persist w250" role="menu">
                <!--  <li class="dropdown-header clearfix">
                    <div class="pull-left ml10">
                        <select id="user-status">
                  <optgroup label="Current Status:">
                    <option value="1-1">Away</option>
                    <option value="1-2">Offline</option>
                    <option value="1-3" selected="selected">Online</option>
                  </optgroup>
                </select>
                    </div>

                    <div class="pull-right mr10">
                        <select id="user-role">
                  <optgroup label="Logged in As:">
                    <option value="1-1">Client</option>
                    <option value="1-2">Editor</option>
                    <option value="1-3" selected="selected">Admin</option>
                  </optgroup>
                </select>
                    </div>
                </li>-->
                <li class="list-group-item">
                    <a [routerLink]="['/profile',user.id]" class="animated animated-short fadeInUp">
                        <span class="fa fa-user "></span> Profile </a>
                </li>
              <!--   <li class="list-group-item">
                    <a href="#" class="animated animated-short fadeInUp">
                        <span class="fa fa-envelope"></span> Messages
                        <span class="label label-warning">2</span>
                    </a>
                </li>
                <li class="list-group-item">
                    <a href="#" class="animated animated-short fadeInUp">
                        <span class="fa fa-gear"></span> Friends
                        <span class="label label-warning">6</span>
                    </a>
                </li>
                <li class="list-group-item">
                    <a href="#" class="animated animated-short fadeInUp">
                        <span class="fa fa-bell"></span> Notifications </a>
                </li> -->

                <li class="dropdown-footer">
                    <a (click)="authService.logout()" class="pointer">
                        <span class="fa fa-power-off pr5"></span> Logout </a>
                </li>
            </ul>
        </li>
    </ul>
</header>
<!-- End: Header -->
